var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "airtel_icn_white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23116",
    transform: "translate(-8001 7664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18915",
    transform: "translate(8001 -7664)",
    fill: "rgba(255,255,255,0)",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16689",
    d: "M3.228 3.267C-1.539 7.585.18 9.029 1.321 9.578s2.658-.2 4.564-1.69 6.3-4.362 7.337-2.932 1.054 4.261-3.394 8S4.455 14.5 6.651 12.8s1.79-2.745.749-2.89c-1.083-.159-2.022.1-3 1.878 0 0-1.488 2.86.419 3.6 1.314.506 5.228-1.069 8.088-3.943 2.109-2.123 3.654-4.665 3-8.059-.822-4.452-7.913-4.438-12.679-.119",
    transform: "translate(8000.941 -7663.757)",
    fill: "#FFF"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "airtel-Fav-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0)",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.169 3.51C-1.598 7.828.121 9.272 1.262 9.821s2.658-.2 4.564-1.69 6.3-4.362 7.337-2.932 1.054 4.261-3.394 8-5.373 1.544-3.177-.156 1.79-2.745.749-2.89c-1.083-.159-2.022.1-3 1.878 0 0-1.488 2.86.419 3.6 1.314.506 5.228-1.069 8.088-3.943 2.109-2.123 3.654-4.665 3-8.059C15.026-.823 7.935-.809 3.169 3.51",
    fill: "#ed1c24"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    id: "airtel"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 225 224"
  }, /*#__PURE__*/React.createElement("image", {
    width: 225,
    height: 224,
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "e094b24b0b0f70a7bf556e982fc87b78",
    fill: "url(#pattern)",
    d: "M0 0h20v20H0z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "back_black"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_black_24dp_4_",
    transform: "translate(24 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20764",
    d: "M0 0h24v24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20765",
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20Z",
    fill: "#2c3e50"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.032 14.347",
    id: "back_white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 6.967 5.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82221",
    d: "M0 16.032V0",
    transform: "translate(5.759)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82222",
    d: "M0 5.759 5.759 0l5.759 5.759",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.445 11.391",
    id: "chev_frwd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1553.193 -374.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-chevron-right",
    d: "m13.5 18.27 4.635-4.635L13.5 9",
    transform: "translate(1540.754 366.965)",
    fill: "none",
    stroke: "#e2e2e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.545 11.589",
    id: "forward_black_icn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-chevron-left",
    d: "m13.5 18.468 4.734-4.734L13.5 9",
    transform: "translate(-12.439 -7.939)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.836 14.701",
    id: "frwd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1135.332 -448.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right",
    d: "m4.166 3.632.747-.747a.8.8 0 0 1 1.141 0l6.546 6.54a.8.8 0 0 1 0 1.141l-6.545 6.545a.8.8 0 0 1-1.141 0l-.747-.747a.81.81 0 0 1 .013-1.155l4.056-3.865H-9.192a.806.806 0 0 1-.808-.808V9.459a.806.806 0 0 1 .808-.808H8.236L4.18 4.787a.8.8 0 0 1-.014-1.155",
    transform: "translate(1145.332 445.502)",
    fill: "#c51e37"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.71 16",
    id: "ic_blue_frwd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_frwd",
    transform: "translate(-132.65 -41.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-right",
    d: "m11.385 11.27-7.12 7.12a.88.88 0 0 1-1.244 0l-.831-.831a.88.88 0 0 1 0-1.242l5.643-5.67-5.644-5.669a.88.88 0 0 1 0-1.242l.831-.831a.88.88 0 0 1 1.244 0l7.121 7.121a.88.88 0 0 1 0 1.244",
    transform: "translate(130.717 38.427)",
    fill: "#3482F5"
  })))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.71 16",
    id: "whiteForward"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.452 8.622-7.12 7.12a.88.88 0 0 1-1.244 0l-.831-.831a.88.88 0 0 1 0-1.242L5.9 7.999.256 2.33a.88.88 0 0 1 0-1.242l.831-.831a.88.88 0 0 1 1.244 0l7.121 7.121a.88.88 0 0 1 0 1.244",
    fill: "#E2E2E2"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.528,
    height: 13.343,
    viewBox: "0 0 17.528 13.343",
    id: "ic_humburger"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-menu",
    d: "M0 13.343h17.528v-2.226H0v2.224Zm0-5.56h17.528V5.56H0zM0-.001v2.224h17.528V0z",
    fill: "#454f63"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.528,
    height: 13.343,
    viewBox: "0 0 17.528 13.343",
    id: "ic_humburger_white"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-menu",
    d: "M6.427 23.626h17.528V21.4H6.427v2.224Zm0-5.56h17.528v-2.223H6.427v2.224Zm0-7.784v2.224h17.528v-2.223z",
    transform: "translate(-6.427 -10.283)",
    fill: "#FFF",
    id: "ham_menu_white"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "brokenImgIcon",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_broken_icon",
    transform: "translate(-241 10270) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_83051",
    "data-name": "Path 83051",
    transform: "translate(-10270 -259)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9L6.951,4.264,9,8.019,6.379,11.971,9,14.943V18H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 1.5 L 1.5 16.5 L 7.5 16.5 L 7.5 15.50964546203613 L 4.493020057678223 12.10107040405273 L 7.250146389007568 7.943813323974609 L 5.266139984130859 4.306949615478516 L 6.614988327026367 1.5 L 1.5 1.5 M 0 0 L 9 0 L 6.951169967651367 4.26360034942627 L 9 8.019289970397949 L 6.378910064697266 11.97142028808594 L 9 14.9425802230835 L 9 18 L 0 18 L 0 0 Z",
    stroke: "none",
    fill: "#454f63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_83052",
    "data-name": "Path 83052",
    transform: "translate(-10259 -259)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H0L-1.951,4.264,0,8.019l-2.379,3.952L0,14.943V18H9Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.9631562232971191 1.5 L -0.2824845314025879 4.221912384033203 L 1.718337059020996 8.073169708251953 L -0.5548362731933594 11.84965705871582 L 1.499996662139893 14.41606998443604 L 1.499996662139893 16.5 L 7.499997138977051 16.5 L 7.499997138977051 1.5 L 0.9631562232971191 1.5 M -3.337860107421875e-06 0 L 8.999997138977051 0 L 8.999997138977051 18 L -3.337860107421875e-06 18 L -3.337860107421875e-06 14.9425802230835 L -2.378903388977051 11.97142028808594 L -3.337860107421875e-06 8.019289970397949 L -1.951172828674316 4.26360034942627 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#454f63"
  }))))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.5 27",
    id: "battarySaverIcnDarkMode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28446",
    transform: "translate(6382.25 3120)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1364",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(-6366 -3118)",
    fill: "#1c274c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-toggle-on",
    d: "M27 4.5H13.5a13.5 13.5 0 0 0 0 27H27a13.5 13.5 0 0 0 0-27m0 22.26a9 9 0 1 1 9-9 8.995 8.995 0 0 1-9 9",
    transform: "translate(-6382.25 -3124.5)",
    fill: "#fff"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.29 28.193",
    id: "battarySaverIcnLightMode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28519",
    transform: "translate(6622.75 3119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.193 4.5H14.1a14.1 14.1 0 1 0 0 28.193h14.1a14.1 14.1 0 1 0 0-28.193ZM14.1 27.918a9.4 9.4 0 1 1 9.4-9.4 9.39 9.39 0 0 1-9.4 9.4",
    transform: "translate(-6622.75 -3123.5)",
    fill: "#ffac33",
    id: "Group_28448"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sun-svgrepo-com",
    transform: "translate(-6615.369 -3111.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82505",
    d: "M5.738.717a.717.717 0 1 1 1.434 0v.717a.717.717 0 1 1-1.434 0Zm6.455 5.021a.717.717 0 0 1 0 1.434h-.717a.717.717 0 0 1 0-1.434Zm-10.759 0a.717.717 0 1 1 0 1.434H.717a.717.717 0 1 1 0-1.434Zm1.837-3.123A.717.717 0 1 1 2.257 3.63l-.507-.507a.717.717 0 0 1 1.014-1.015Zm7.529 7.531a.717.717 0 0 1-1.014 1.014l-.507-.507a.717.717 0 0 1 1.014-1.014zm-.146-6.516A.717.717 0 0 1 9.64 2.615l.507-.507a.717.717 0 0 1 1.014 1.014zm-7.531 7.531a.717.717 0 0 1-1.014-1.014l.507-.507a.717.717 0 0 1 1.014 1.013zm2.615.315a.717.717 0 0 1 1.434 0v.717a.717.717 0 0 1-1.434 0Z",
    fill: "#ffac33"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1365",
    cx: 3.443,
    cy: 3.443,
    r: 3.443,
    transform: "translate(3.012 3.012)",
    fill: "#ffac33"
  }))))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 101",
    id: "locked"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 4c6.273 4.743 10.317 10.272 12 18 .28 3.512.41 7.032.322 10.555-.045 2.26-.045 2.26.678 5.445 2.788 1.748 2.788 1.748 6 3 2.485 2.192 3.825 3.955 4.38 7.264.167 2.845.2 5.663.186 8.513l.02 3.164q.01 3.308-.01 6.614c-.013 3.368.02 6.732.059 10.1q0 3.217-.006 6.435l.04 3.04c-.06 4.568-.141 7.848-3.083 11.49-3.857 3.55-5.789 3.517-10.96 3.573l-1.982.025q-3.25.035-6.503.055l-2.245.017q-5.886.039-11.77.06-4.866.02-9.73.082c-3.92.05-7.837.074-11.756.081q-2.236.01-4.473.046c-13.136.2-13.136.2-17.066-2.967-2.722-3.358-3.228-4.908-3.294-9.13l-.049-2.853c-.044-4.313-.085-8.625-.108-12.938a716 716 0 0 0-.082-6.82 803 803 0 0 1-.091-9.835l-.07-3.07c.014-4.557.03-7.896 2.95-11.549C4.894 40.096 6.73 38.934 10 38l.078-3.148c.374-10.471 1.214-19.138 8.547-27.227C29.161-1.908 46.797-3.742 59 4M24 15c-5.646 7.169-4 13.43-4 23h42c.892-12.629.892-12.629-4-23-4.848-4.656-10.204-6.587-16.875-7.312C34.703 8.33 28.515 10.227 24 15",
    fill: "#B1141B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 4c6.236 4.715 10.466 10.262 12 18 .415 5.666.237 11.33 0 17h-9l-.078-3.219C61.633 24.776 61.633 24.776 57 15c-5.379-4.542-10.95-6.314-17.937-5.875-6.542.866-11.344 2.715-15.5 7.938-2.506 4.71-2.847 8.895-3.125 14.125l-.131 2.271Q20.149 36.229 20 39h-9c-.502-12.017-.894-21.942 7.625-31.375C29.161-1.908 46.797-3.742 59 4",
    fill: "#283E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.563 54.063C44.306 55.118 45.303 55.608 47 58c.326 2.745.464 5.197.438 7.938l.06 2.17c-.003 3.538-.229 5.53-2.365 8.4C43 78 43 78 40.437 77.938 37.695 76.882 36.698 76.392 35 74a60 60 0 0 1-.437-7.937l-.061-2.17c.003-3.539.229-5.531 2.365-8.4C39 54 39 54 41.563 54.062",
    fill: "#F2EBEF"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.181 61.181",
    id: "acc_locked_icn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26853",
    transform: "translate(-159.5 -538.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2542093_block_blocked_private_stop_icon",
    transform: "translate(160 538.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79495",
    d: "M32.091 62.181a30.091 30.091 0 1 1 30.09-30.09 30.125 30.125 0 0 1-30.09 30.09Zm0-57.674a27.583 27.583 0 1 0 27.583 27.584A27.614 27.614 0 0 0 32.091 4.508Z",
    transform: "translate(-2 -2)",
    fill: "#925fa1",
    stroke: "#925fa1",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26851",
    transform: "translate(10.063 8.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22188",
    transform: "rotate(-44.999 .65 .269)",
    fill: "#925fa1",
    stroke: "#925fa1",
    strokeWidth: 3,
    d: "M0 0h.761v17.514H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26852",
    transform: "translate(38.027 36.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26850-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79496",
    d: "m0 0 .751.011.242 17.277-.751-.011Z",
    transform: "rotate(-44.999 .847 .351)",
    fill: "#925fa1",
    stroke: "#925fa1",
    strokeWidth: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(175.045 551.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1169",
    cx: 7.237,
    cy: 8.685,
    rx: 7.237,
    ry: 8.685,
    transform: "translate(7.26)",
    fill: "#ec1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79494",
    d: "M30.666 21.042a13.2 13.2 0 0 0-6.948-6.079 3.24 3.24 0 0 0-2.605.145 8.89 8.89 0 0 1-9.264 0 3.26 3.26 0 0 0-2.605 0A13.2 13.2 0 0 0 2.3 21.186a2.857 2.857 0 0 0 2.75 4.053h22.866a2.932 2.932 0 0 0 2.75-4.197",
    transform: "translate(-1.984 3.71)",
    fill: "#ec1b24"
  })))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 36 36",
    id: "ic_close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.492 10.508a1.504 1.504 0 0 0 0 2.125l5.38 5.375-5.38 5.379a1.5 1.5 0 1 0 2.121 2.12l5.38-5.378 5.374 5.379c.586.586 1.54.586 2.125 0a1.507 1.507 0 0 0 0-2.121l-5.379-5.38 5.38-5.374a1.51 1.51 0 0 0 0-2.125 1.504 1.504 0 0 0-2.126 0l-5.375 5.379-5.379-5.38a1.5 1.5 0 0 0-2.12 0m0 0"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic_close_white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.995 7.006a1 1 0 0 0 0 1.415l3.585 3.585-3.585 3.585a1 1 0 1 0 1.414 1.414l3.585-3.585 3.585 3.585a1 1 0 0 0 1.415-1.414l-3.586-3.585 3.586-3.585a1 1 0 0 0-1.415-1.415l-3.585 3.585L8.41 7.007a1 1 0 0 0-1.414 0",
    fill: "#FFF"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic_cancel_red",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel",
    d: "M13 3a10 10 0 1 0 10 10A9.99 9.99 0 0 0 13 3",
    transform: "translate(-3 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel-2",
    d: "M13 3a10 10 0 1 0 10 10A9.99 9.99 0 0 0 13 3m5 13.59L16.59 18 13 14.41 9.41 18 8 16.59 11.59 13 8 9.41 9.41 8 13 11.59 16.59 8 18 9.41 14.41 13Z",
    transform: "translate(-3 -3)",
    fill: "red"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "ic_cancel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A9.99 9.99 0 0 0 10 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A9.99 9.99 0 0 0 10 0m5 13.59L13.59 15 10 11.41 6.41 15 5 13.59 8.59 10 5 6.41 6.41 5 10 8.59 13.59 5 15 6.41 11.41 10Z",
    fill: "#a8a8a8"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.25 29.25",
    id: "ic_check"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8112 8688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    d: "M18 3.375A14.625 14.625 0 1 0 32.625 18 14.623 14.623 0 0 0 18 3.375",
    transform: "translate(-8115.375 -8691.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle-2",
    d: "M18 3.375A14.625 14.625 0 1 0 32.625 18 14.623 14.623 0 0 0 18 3.375m7.488 10.582-9.4 9.443h-.008a1.27 1.27 0 0 1-.816.387 1.23 1.23 0 0 1-.823-.4L10.5 19.448a.28.28 0 0 1 0-.4l1.256-1.248a.27.27 0 0 1 .394 0l3.122 3.122 8.578-8.641a.28.28 0 0 1 .2-.084.26.26 0 0 1 .2.084l1.23 1.273a.277.277 0 0 1 .008.403",
    transform: "translate(-8115.375 -8691.375)",
    fill: "#5ecc89"
  })))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    id: "ic_clock"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-262 -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1481",
    transform: "translate(262 141)",
    fill: "none",
    stroke: "#fea800",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 21.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82559",
    d: "M-12419.5-8625.862v10.344h8.43",
    transform: "translate(12704.5 8780)",
    fill: "none",
    stroke: "#fea800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.024 80.024",
    id: "successful"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.012 0a40.012 40.012 0 1 0 40.013 40.012A40.006 40.006 0 0 0 40.012 0m20.487 28.951L34.78 54.786h-.019a3.47 3.47 0 0 1-2.236 1.058 3.37 3.37 0 0 1-2.251-1.1L19.506 43.975a.766.766 0 0 1 0-1.1l3.424-3.424a.744.744 0 0 1 1.077 0l8.541 8.541 23.469-23.638a.76.76 0 0 1 .539-.231.7.7 0 0 1 .539.231l3.366 3.482a.76.76 0 0 1 .038 1.115",
    fill: "#4bd13a"
  }))), /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 84 84",
    id: "red-x-icon"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#ec1a23",
      fillOpacity: 1
    },
    d: "M41.96 0c23.173 0 41.958 18.785 41.958 41.957 0 23.176-18.785 41.961-41.957 41.961C18.785 83.918 0 65.133 0 41.957 0 18.785 18.785 0 41.96 0m8.2 26.738a4.785 4.785 0 0 1 6.82-.02 4.91 4.91 0 0 1 .02 6.887l-8.238 8.356 8.246 8.367c1.863 1.89 1.836 4.957-.055 6.844-1.894 1.887-4.937 1.883-6.797-.008l-8.191-8.309-8.211 8.325a4.784 4.784 0 0 1-6.816.02c-1.887-1.9-1.899-4.981-.02-6.888l8.238-8.359-8.246-8.363c-1.863-1.89-1.836-4.957.055-6.844 1.894-1.89 4.937-1.883 6.797.008l8.195 8.308Zm0 0"
  })), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16.563",
    id: "share"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1351.707 -526.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-share",
    d: "M16.993 14.829a2.28 2.28 0 0 0-1.63.624L9.388 12a2.8 2.8 0 0 0 .084-.583 2.8 2.8 0 0 0-.084-.583l5.892-3.412a2.5 2.5 0 1 0-.794-1.831 2.8 2.8 0 0 0 .084.583L8.678 9.586a2.52 2.52 0 0 0-1.713-.666 2.474 2.474 0 0 0-2.465 2.5 2.515 2.515 0 0 0 4.22 1.831l5.933 3.449a2 2 0 0 0-.084.541 2.423 2.423 0 1 0 2.423-2.414Z",
    transform: "translate(1347.207 523.605)"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16.563",
    id: "share-white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.493 11.735a2.28 2.28 0 0 0-1.63.624L4.888 8.906a2.8 2.8 0 0 0 .084-.583 2.8 2.8 0 0 0-.084-.583l5.892-3.412a2.5 2.5 0 1 0-.794-1.831 2.8 2.8 0 0 0 .084.583L4.178 6.492a2.52 2.52 0 0 0-1.713-.666A2.474 2.474 0 0 0 0 8.326a2.515 2.515 0 0 0 4.22 1.831l5.933 3.449a2 2 0 0 0-.084.541 2.423 2.423 0 1 0 2.423-2.414Z",
    fill: "#FFF"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.032 17.782",
    id: "ic_star_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16540",
    d: "M15.285 18.682a.3.3 0 0 1-.243-.081l-5.193-3.327L4.576 18.6a.52.52 0 0 1-.487 0c-.162-.081-.162-.243-.162-.406l1.623-5.923L.681 8.459A1 1 0 0 1 .6 7.972a.375.375 0 0 1 .406-.243L7.253 7.4l2.191-5.757a.45.45 0 0 1 .405-.243.45.45 0 0 1 .406.243L12.446 7.4l6.247.325a.45.45 0 0 1 .406.243.3.3 0 0 1-.162.406l-4.868 3.813 1.623 5.923a.3.3 0 0 1-.162.406c-.082.084-.163.166-.245.166ZM2.142 8.378 6.361 11.7c.162.081.162.243.162.406L5.062 17.3l4.544-2.921a.36.36 0 0 1 .406 0l4.543 2.921-1.46-5.193a.3.3 0 0 1 .162-.406l4.219-3.327-5.436-.24c-.162 0-.325-.081-.325-.243L9.849 2.86 7.9 7.891c-.081.162-.162.243-.325.243Z",
    transform: "translate(-.35 -1.15)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    id: "ic_star"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefffe",
    d: "M49.5 17.5v3a102 102 0 0 0-13 11 63.2 63.2 0 0 1 4 17 95.4 95.4 0 0 1-16-9 95.4 95.4 0 0 1-16 9 63.2 63.2 0 0 1 4-17 102 102 0 0 0-13-11v-3l18-1 5-16h4l5 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalSprite);
export default __webpack_public_path__ + "static/media/local_sprite.8dc92ec45afbfb1d3ee70ca38edf73c2.svg";
export { ForwardRef as ReactComponent };